export const ADD_RECORD_TIME = 'ADD_RECORD_TIME';
export const SET_RECORD_TIME = 'SET_RECORD_TIME';
export const ADD_PATIENT_HEALTH_QUESTIONNAIRE = 'ADD_PATIENT_HEALTH_QUESTIONNAIRE';
export const SET_PATIENT_HEALTH_QUESTIONNAIRE = 'SET_PATIENT_HEALTH_QUESTIONNAIRE';
